import React from 'react';
import { SL_PREMIUM } from '@surfline/web-common';
import MeterPremiumPaywall from '../bundles/margins/metering/MeterPremiumPaywall';
import MeterBottomSheetRegWall from '../bundles/margins/metering/MeterBottomSheetRegWall';

/**
 * Utility function for Metering Modals. This is a centralized location for all Meter related logic in backplane.
 * Depending on the meter state of a user this function determines which Modal to be rendered based on the treatment variant the user is in.
 * @param {import('@surfline/web-common').MeterState} meter
 * @param {import('@surfline/web-common').UserState} user
 * @param {string[]} entitlements
 * @return {JSX.Element | null}
 */
export const computeMeterModal = (meter, user, entitlements) => {
  const isPremium = entitlements?.includes(SL_PREMIUM);

  const isAnonymous = !user;

  if (!meter || isPremium) {
    return null;
  }

  const { treatmentState, meterRemaining } = meter;

  // Anonymous Sessions
  if (isAnonymous) {
    // If treatment is OFF then don't show the Modals
    if (treatmentState === 'off') {
      return null;
    }
    // If the variant is surf_check or account_benefits then compute the surf check eligibility
    // Eligible for a surf check if meterRemaining > -1. Don't show the RegWall Modal.
    const isSurfCheckEligible = meterRemaining > -1;
    return isSurfCheckEligible ? null : <MeterBottomSheetRegWall />;
  }

  // If treatment is OFF then don't show the Modals
  if (treatmentState === 'off') {
    return null;
  }
  // If the variant is surf_check or account_benefits then compute the surf check eligibility
  // Eligible for a surf check if meterRemaining > -1. Don't show the RegWall Modal.
  const isSurfCheckEligible = meterRemaining > -1;
  return isSurfCheckEligible ? null : <MeterPremiumPaywall />;
};
